import { post, destroy, put } from '.';

export function CreateResourceNote(options = {}) {
    return post<any>(`/app/api/resource_notes`, options);
}

export function DestroyResourceNote(id: string) {
    return destroy<any>(`/app/api/resource_notes/${id}`);
}

export function UpdateResourceNote(id: string, options = {}) {
    return put<any>(`/app/api/resource_notes/${id}`, options);
}